module.exports = __webpack_public_path__ + "media/images/icons/vendors/caterers2-34e8d689838c7d4c0c460c4f46afbdbe.png";